import WPAPIService from "../../wp-rest/posts";
const { useState } = wp.element;

function CategorySelectComponent(props) {
  const categories = WPAPIService("/wp-json/wp/v2/package/");
  const [isActive, setisActive] = useState(false);

  let categoryClick = (event, index) => {
    let selectedCategory = event.target.value;
    setisActive(index);
    props.channelCategoryCallback(selectedCategory);
  };
  return (
    <div className="packages-wrapper">
      <button onClick={categoryClick} className="single-category" value="22,23,24,25,26">
        <h4>All Channels</h4>
      </button>
      {categories[0] &&
        categories[0].map((category, index) => (
          <button
            onClick={(event, index) => categoryClick(event, index)}
            className={"single-category" + (index === isActive ? " active" : "")}
            value={category.id}
            key={index}
          >
            <h4>{category.name}</h4>
          </button>
        ))}
    </div>
  );
}
export default CategorySelectComponent;



// WEBPACK FOOTER //
// ./react/components/category-select/category-select-component.jsx